<template>
  <v-card flat>
    <div id="login_form_bem_vindo" class="text-center">
      <h1>Bem vindo(a)</h1>

      <cs-message
        :type="error.type"
        v-if="error.message[0]"
        v-model="error.message"
        class="errorMessage"
      />

      <v-form v-model="valid" lazy-validation>
        <cs-text-field
          ref="login"
          class="textField"
          v-model="login"
          :label="loginLabel"
          :placeholder="loginPlaceholder"
          :rules="rules.required"
        />

        <cs-text-field
          ref="password"
          type="password"
          class="textField password"
          v-model="password"
          :label="passwordLabel"
          :placeholder="passwordPlaceholder"
          :rules="rules.required"
          password
        />
        <div class="text-right text-mini mb-9">
          <a href="/forgotpassword"> Esqueceu sua senha? </a>
        </div>
        <cs-recaptcha
          v-if="!captchaNotRequired"
          class="recaptcha"
          ref="vue_recaptcha"
          v-model="recaptcha"
          :sitekey="global.recaptchaKey"
          action="login"
        />
        <div id="termsOfService">
          <terms-of-service
            v-if="showTermsOfUse || requestTermsOfUse"
            openDialog
            @onAcceptTerms="handleAcceptTerms"
            @onDialogAccepted="handleDialogAcceptedTerms"
          ></terms-of-service>
        </div>
        <request
          id="login_btn"
          method="post"
          class="w-100"
          ref="enterButton"
          :headers="headers"
          :params="params"
          :textButton="text"
          :url="global.logInUrl"
          :value="logInValue()"
          :disabled="disableButton"
          @resolved="handleLog($event)"
          @click="error.message = []"
        >
          {{ text }}
        </request>
      </v-form>
      <v-snackbar :value="snack">
        <v-icon class="pr-1">mdi-checkbox-marked-circle</v-icon>
        Sua senha foi redefinida com sucesso.
      </v-snackbar>
    </div>
  </v-card>
</template>

<script>
import csMessage from '@/components/campos/csMessage.vue'
import csRecaptcha from '@/components/campos/csRecaptcha.vue'
import csTextField from '@/components/campos/csTextField.vue'
import Request from '@/components/Request.vue'
import termsOfService from '@/components/TermsOfService/termsOfService.vue'
import { recaptchaDisabledUrls } from '@/constants'
import qs from 'qs'
import { mapState } from 'vuex'

export default {
  components: {
    Request,
    csTextField,
    csRecaptcha,
    csMessage,
    termsOfService
  },
  data: () => ({
    attemptedLogin: false,
    login: '',
    password: '',
    text: 'Entrar',
    rememberMe: true,
    showPass: false,
    recaptcha: '',
    captchaRequired: true,
    valid: false,
    rules: {
      required: [(val) => (val || '').length > 0 || 'Esse campo é obrigatório']
    },
    showTermsOfUse: false,
    requestTermsOfUse: false,
    termsAccepted: false,
    error: {
      type: '',
      message: []
    }
  }),
  mounted() {
    this.$nextTick(() => {
      this.login = ''
      this.password = ''
      if (this.global.logged) {
        window.location.href = this.global.redirectPortalUrl
      }
    })
    this.checkCaptchaRequirement()
  },
  computed: {
    ...mapState(['global']),
    captchaNotRequired() {
      var isDisabled = recaptchaDisabledUrls.some((u) => window.location.hostname === u)
      return isDisabled || !this.captchaRequired
    },
    disableButton() {
      if ((this.login && this.password) === '') {
        return true
      } else if (!this.allowSubmit || (this.requestTermsOfUse ? !this.termsAccepted : false)) return
    },
    loginPlaceholder() {
      if (this.$route.query.ReturnUrl) {
        const decodedReturnUrl = decodeURI(this.$route.query.ReturnUrl)

        const params = new URL(`https://${decodedReturnUrl}`).searchParams

        const clientId = params.get('client_id')

        if (clientId && clientId == this.global.loginPlaceHolderClientId) {
          return this.global.loginPlaceHolderText
        }
      }

      return this.login === '' ? 'Login' : ''
    },
    loginLabel() {
      return this.login === '' ? '' : 'Login'
    },
    passwordPlaceholder() {
      return this.password === '' ? 'Senha' : ''
    },
    passwordLabel() {
      return this.password === '' ? '' : 'Senha'
    },
    allowSubmit() {
      const fakeKeyRepactcha = 'f9c7af7ebcbf098b9f5f37361d1b168bb2e5b98d930ceef0f055377a8c94db6'
      if (this.captchaNotRequired) this.recaptcha = fakeKeyRepactcha
      return this.valid && this.recaptcha !== ''
    },
    claims() {
      return this.global.Claims && this.global.Claims.split(',')
    },
    requestToken() {
      const _el = document.getElementsByName('__RequestVerificationToken')[0]
      return _el && _el.value
    },
    headers() {
      const headerContent = { 'Content-Type': 'application/json' }
      if (this.requestToken) {
        headerContent.RequestVerificationToken = this.requestToken
      }
      return headerContent
    },
    params() {
      return this.$route.query
    },
    logOffValue() {
      return qs.stringify({ __RequestVerificationToken: this.requestToken })
    },
    snack() {
      return this.$route.params?.changedPass
    }
  },
  methods: {
    handleLog(event) {
      this.attemptedLogin = true
      const statusCode = event.status
      const is200 = statusCode === 200
      const is503 = statusCode === 503
      if (is200 || (event.data && event.data.data)) {
        const _retUrl = this.$route.query.ReturnUrl && this.$route.query.ReturnUrl.slice(1)
        const baseUrl = _retUrl ? process.env.BASE_URL + _retUrl : this.global.DefaultUrl
        window.location = event.data.data !== null ? event.data.data.redirectUri : baseUrl
      } else if (event.data && event.data.errors) {
        if (!this.captchaNotRequired) {
          this.recaptcha = ''
          this.$refs.vue_recaptcha.reset()
        }
        if (event.data.errors[409]) {
          this.showTermsOfUse = true
          this.requestTermsOfUse = true
          return
        }
        if (event.data.errors[410]) {
          this.$router.push({
            name: 'ForgotPassword',
            params: { trustHubError: event.data.errors[410][0] }
          })
          return
        }
        if (!this.global.logged) {
          this.error.message.push(event.data.errors[''][0])
          this.error.type = 'error'
        }
        for (const chave in event.data.errors) {
          this[chave + 'Errors'] = event.data.errors[chave]
        }
      } else if (is503) {
        this.error.message.push(
          'Não foi possível processar as informações. Tente novamente mais tarde'
        )

        this.error.type = 'error'
      } else {
        console.log(event || 'Erro ao logar ou deslogar')
      }
    },
    logInValue() {
      const fakeKeyRepactcha = 'f9c7af7ebcbf098b9f5f37361d1b168bb2e5b98d930ceef0f055377a8c94db6'
      if (!this.requestTermsOfUse) {
        return {
          login: this.login,
          password: this.password,
          rememberMe: this.rememberMe,
          recaptcha: !this.captchaNotRequired ? this.recaptcha : fakeKeyRepactcha
        }
      } else {
        return {
          login: this.login,
          password: this.password,
          rememberMe: this.rememberMe,
          recaptcha: !this.captchaNotRequired ? this.recaptcha : fakeKeyRepactcha,
          termsOfUse: this.termsAccepted
        }
      }
    },
    handleAcceptTerms(accept) {
      this.error.message = []
      if (accept) {
        this.error.type = 'success'
        this.error.message.push(
          'Termos aceitos com sucesso! Por segurança é necessário fazer login novamente.'
        )
        this.termsAccepted = true
      } else {
        this.error.type = 'warning'
        this.error.message.push('É necessário aceitar os termos atuais. Entre novamente.')
        this.termsAccepted = false
      }
    },
    handleDialogAcceptedTerms() {
      this.handleAcceptTerms(true)
      if (this.allowSubmit) {
        this.$nextTick(() => {
          this.$refs.enterButton.submit()
        })
      }
    },
    checkCaptchaRequirement() {
      this.$http.get('/api/v3/account/captcha-required').then((response) => {
        this.captchaRequired = response.data.isRequired
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.password {
  ::v-deep .v-input {
    margin-bottom: 1.188rem !important;
  }
}

.recaptcha {
  margin-bottom: 1rem !important;
}

@media (min-width: 600px) and (max-width: 959px) {
  .textField {
    min-width: 36.5rem !important;
  }

  .errorMessage {
    width: 36.5rem !important;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .textField {
    min-width: 23.625rem !important;
  }

  .errorMessage {
    width: 23.625rem !important;
  }
}

@media (min-width: 1264px) {
  .textField {
    min-width: 23.625rem !important;
  }

  .errorMessage {
    width: 23.625rem !important;
  }
}
</style>
